import React, { useEffect, useState } from "react";
import Header from "../header/header";
import HeaderImageSection from "../shared/headerImageSection";
import FooterComponent from "../footerComponent/footerComponent";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import "./help.scss";
import axios from "axios";
import { API_URL } from "../../variables";

const Help = () => {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getVideos();
  }, []);

  const getVideos = async () => {
    let res = await axios.get(API_URL + "get_youtube_links");
    if (res?.data?.videos.length > 0) setLinks(res?.data?.videos);
  };
  return (
    <>
      <Header />
      <HeaderImageSection />
      <section className="p-4 container bg-white mt-4">
        <label className="headerLabel">Help</label>
        <div className="row">
          {links?.map((item, index) => {
            return (
              <div className="col-sm-4 col-md-4 p-2 mb-3" key={index}>
                {/* <div className="videoContainerImg d-flex align-items-center justify-content-center ">
                  <PlayCircleIcon className="playIcon" />
                </div>
                <label className="textDarkRed font18px font-bold">
                  How to register yourself
                </label> */}
                <iframe
                  className="homeVideoFrame"
                  width="350"
                  height="300"
                  src={"https://www.youtube.com/embed/" + item.youtube_link} // Replace with your video ID
                  title="YouTube video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
                <label className="textDarkRed font18px font-bold">
                  {item.title}
                </label>
              </div>
            );
          })}

          {/* <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to register yourself
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to get response
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to Change the profile photo
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to register yourself
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to get response
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to Change the profile photo
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to register yourself
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to get response
            </label>
          </div>
          <div className="col-sm-4 col-md-4 p-2 mb-3">
            <div className="videoContainerImg d-flex align-items-center justify-content-center ">
              <PlayCircleIcon className="playIcon" />
            </div>
            <label className="textDarkRed font18px font-bold">
              How to Change the profile photo
            </label>
          </div> */}
        </div>
      </section>
      <FooterComponent />
    </>
  );
};

export default Help;
